const profile = {
  name: "Swalih Kolakkadan",
  userName: "swalihKolakkadan",
  aboutMe:
    "A passionate software engineer specializing in crafting immersive and intuitive web experiences. With a deep love for all things frontend, I blend the art of design with the science of programming to bring ideas to life on the web.",
  designation: "Sr Software Engineer",
  currentCompany: "Qburst",
  contactNo: "8592815130",
  email: "swalih723@gmail.com",
  workEmail: "swalihkolakkadan@gmail.com",
  birthday: "May 5, 1998",
  city: "Kozhikode",
  linkedIn: "https://www.linkedin.com/in/swalih-kolakkadan/",
  github: "https://github.com/swalihkolakkadan",
  siteUrl: "https://swalih-kolakkadan.vercel.app",
};

export { profile };
